import type { BanDich } from '../../types';
import type { viRpaAgent } from './agent.vi';

export const enRpaAgent: Pick<BanDich, keyof typeof viRpaAgent> = {
  rpaAgent: {
    moTa: 'Give an agent (Hermes / OpenClaw) a task to read OpenRPA data and error reports and suggest fixes.',
    daGiao: 'Task sent to the agent. The result appears in the list when the agent finishes.',
    phamViNgay: 'Last {{so}} days',
    ketNoi: {
      daKetNoi: 'Agent connected',
      danhSach: 'Available agents: {{ds}}',
      chuaCauHinh: 'Not configured',
      chuaCauHinhGoiY: 'The RPA server has no RPA_AGENT_GATEWAY_URL and RPA_AGENT_GATEWAY_KEY. Contact your system administrator.',
      khongKetNoi: 'Unreachable',
      khongKetNoiGoiY: 'Could not reach the Agent Gateway. Check the agent server and the network path (VPN, firewall).',
    },
    mauNhan: {
      errors: 'Analyse errors',
      overview: 'Operations summary',
      retry: 'Suggest reruns',
    },
    mauNoiDung: {
      errors:
        'Analyse failed and cancelled runs: which workflows fail most, at which step, the likely causes and how to fix them.',
      overview:
        'Summarise RPA operations: runs and success rate per workflow, which machines run the most, and points that need attention.',
      retry:
        'List failed runs that are safe to rerun (transient errors such as timeouts, network issues or locked files) and suggest rerunning them.',
    },
    form: {
      tieuDe: 'Give the agent a task',
      moTa: 'The agent reads runs, incidents and workflows from OpenCore within the selected range.',
      khongCoQuyen: 'You cannot give the agent tasks yet',
      khongCoQuyenMoTa: 'Requires the {{quyen}} permission. You can still view tasks and results in the list.',
      chuaKetNoi: 'Tasks cannot be sent while the Agent Gateway is not connected.',
      mauNhanh: 'Quick templates',
      agent: 'Agent',
      phamVi: 'Data range',
      phamViGoiY: 'The period of runs sent to the agent.',
      yeuCau: 'Request',
      yeuCauGoiY: 'Describe what the agent should do. The agent only reads data and suggests; it never runs robots on its own.',
      yeuCauMau: 'For example: How many times did the TOPCV v2 flow fail this week, and at which step?',
      batBuoc: 'Enter a request for the agent.',
      quaDai: 'The request is longer than {{max}} characters.',
      gui: 'Send to agent',
      dangGui: 'Sending...',
    },
    ds: {
      tieuDe: 'Tasks',
      moTa: 'Latest 50 tasks',
      daTai: 'Latest {{so}} tasks (up to 50). Updates automatically while a task is running.',
      rong: 'No tasks yet',
      rongMoTa: 'Give the first task in the panel beside, for example with the “Analyse errors” template.',
      cotThoiGian: 'Time',
      cotYeuCau: 'Request',
      cotAgent: 'Agent',
      cotTrangThai: 'Status',
      cotThoiLuong: 'Duration',
      xem: 'View result',
      daCho: 'Waited {{tg}}',
    },
    huy: {
      nut: 'Cancel task',
      tieuDe: 'Cancel the running task?',
      than: 'The task stops and frees its slot right away. The request already sent may keep running on the agent side. This cannot be undone.',
      daHuy: 'Task cancelled.',
    },
    trangThai: {
      running: 'Processing',
      completed: 'Completed',
      failed: 'Failed',
    },
    hanhDong: {
      retry_run: 'Rerun',
      run_workflow: 'Run workflow',
      check_robot: 'Check machine',
      review_workflow: 'Review workflow',
    },
    chiTiet: {
      tieuDe: 'Agent task details',
      trangThai: 'Status',
      agent: 'Agent',
      phamVi: 'Data range',
      giaoLuc: 'Assigned at',
      thoiLuong: 'Processing time',
      yeuCau: 'Request',
      dangXuLy: 'The agent is working. The result shows up when it finishes.',
      loi: 'The agent could not complete the request',
      baoCao: 'Agent report',
      deXuat: 'Suggested actions ({{so}})',
      khongDeXuat: 'The agent suggested no actions.',
      moMan: 'Open related screen',
      ghiChu:
        'These are the agent’s suggestions and never run on their own. Only people with execute permission can run them, after checking and confirming each one.',
    },
    thucThi: {
      thucThi: 'Execute',
      kiemTra: 'Check now',
      thuLai: 'Retry',
      tieuDeChay: 'Run the workflow the agent suggested?',
      tieuDeChayLai: 'Rerun the failed run?',
      nutChay: 'Run workflow',
      nutChayLai: 'Rerun',
      hanhDong: 'Action',
      workflow: 'Workflow to run',
      luotLoi: 'Failed run',
      luotLoiLuc: 'Failed at',
      lyDo: 'Agent’s reason',
      robot: 'Running robot',
      robotCuaBan: '{{ten}} (your connected OpenCore account)',
      robotLicense: 'The robot of the project’s licence',
      project: 'Project',
      projectGoiY: 'Only projects assigned this workflow and holding a valid licence are shown.',
      chonProject: 'Select a project',
      khongCoProject:
        'No project is both assigned this workflow and holding a valid licence. Check licences and workflow assignments on the Projects screen.',
      ghiChuChay: 'The robot runs for real right after you confirm. This action can be executed only once.',
      ghiChuChayLai:
        'The workflow reruns with the failed run’s input data. The robot runs for real right after you confirm, and only once.',
      daGuiChay: 'Run command sent. Follow the result on the Run history screen.',
      daGuiChayLai: 'Rerun command sent. Follow the result on the Run history screen.',
      daKiem: 'Robot checked.',
      dangChay: 'Executing...',
      loi: 'Execution failed',
      daXong: 'Executed',
      luc: 'at {{luc}}',
      xemLichSu: 'View run history',
      robotDong: 'Robot {{ten}} · machine {{may}} · status {{tt}}',
      tkBat: 'OpenCore account enabled',
      tkKhoa: 'OpenCore account locked',
      tkKhongRo: 'could not read the OpenCore account status',
    },
  },
};
